// toggle hamburger menu
const hamburgerBtn = document.querySelector(".hamburger-menu");
const hamburgerMenu = document.querySelector(".hamburger-menu__nav--overlay");
const acceptCookies = document.querySelector(".cookies-information__btn");
const cookiesInformation = document.querySelector(".cookies-information");
const localStorageCookiesKey = "didUserAcceptCookies";

const toggleHamburgerMenuAndAnimateBtn = () => {
  hamburgerBtn.classList.toggle("change");
  hamburgerMenu.classList.toggle("show");
};

hamburgerBtn.addEventListener("click", () => {
  toggleHamburgerMenuAndAnimateBtn();
});

// smooth scrolling after nav item click
const elementsScrollTo = [
  {
    className: "about-us",
    distanceFromTop: null
  },
  {
    className: "offer",
    distanceFromTop: null
  },
  {
    className: "find-us",
    distanceFromTop: null
  },
  {
    className: "contact",
    distanceFromTop: null
  }
];

elementsScrollTo.forEach((el, index) => {
  const distance = document.querySelector(`.${el.className}`).offsetTop;
  elementsScrollTo[index].distanceFromTop = distance;
});

const navList = document.querySelector(".nav").children;
Array.from(navList).forEach((el, index) => {
  el.addEventListener("click", () => {
    window.scroll({
      top: elementsScrollTo[index].distanceFromTop + 1,
      left: 0,
      behavior: "smooth"
    });
  });
});

const hamburgerNavList = document.querySelector(".hamburger-menu__nav")
  .children;
Array.from(hamburgerNavList).forEach((el, index) => {
  el.addEventListener("click", () => {
    window.scroll({
      top: elementsScrollTo[index].distanceFromTop + 1,
      left: 0,
      behavior: "smooth"
    });
    toggleHamburgerMenuAndAnimateBtn();
  });
});

// arrow back to the top
const arrowScrollUp = document.querySelector(".arrow");

arrowScrollUp.addEventListener("click", () => {
  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
});

const hideCookiesInformation = () => {
  cookiesInformation.style.visibility = "hidden";
  localStorage.setItem(localStorageCookiesKey, "true")
}

acceptCookies.addEventListener("click", () => {
  hideCookiesInformation()
})

const app = () => {
  const didUserAcceptCookies = localStorage.getItem(localStorageCookiesKey)
  if (didUserAcceptCookies === "true") {
    hideCookiesInformation()
  }
}

app();


// WEBPACK FOOTER //
// ./src/scripts/app.js